import React from 'react';
import {
  Container,
  Flex,
  Text,
  Stack,
  Heading,
  Image,
  UnorderedList,
  ListItem
} from '@chakra-ui/react';
import { COLORS } from "../../../colors";

const Section = ({ imageSrcs, title, description, listItems, imageOnRight }) => {
  return (
    <Stack direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} spacing={10}>
      <Flex
        p={8}
        flex={1}
        align={'top'}
        justify={'center'}
        order={{ base: 1, md: imageOnRight ? 2 : 1 }}
      >
        <Stack spacing={6} w={'full'} maxW={'lg'} vertical-align={'top'}>
          <Heading textAlign={"center"} as="h2" size="xl" mt={0} mb={2} fontFamily={"Montserrat"} color={COLORS.brand1}>
            {title}
          </Heading>
          <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            {description}
          </Text>
          {listItems && (
            <UnorderedList textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
              {listItems.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </UnorderedList>
          )}
        </Stack>
      </Flex>
      <Flex
        flexDirection='column'
        flex={1}
        order={{ base: 2, md: imageOnRight ? 1 : 2 }}
      >
        {imageSrcs.map((src, index) => (
          <Image
            key={index}
            alt={'Section Image'}
            objectFit={'cover'}
            src={src}
            maxH={{ base: '400px', md: '400px' }} // Ajusta esta altura según lo deseado
            w={'100%'}
            mb={0} // Margin bottom for spacing between images
          />
        ))}
      </Flex>
    </Stack>
  );
};

const A2 = () => {
  return (
    <Section
      imageSrcs={["/a1.jpg"]}
      title="NIVEL A1"
      description="El objetivo principal es que puedas realmente comunicarte en inglés con una buena pronunciación y tener la confianza de utilizar el inglés de una forma efectiva y a su vez complementar y enriquecer el inglés ya aprendido."
      imageOnRight={false}
    />
  );
};

const B1 = () => {
  return (
    <Section
      imageSrcs={["/b1.jpg"]}
      title="NIVEL B1"
      description="En el mundo actual el conocimiento de inglés es clave en nuestra cultura moderna. Es esencial para visitar otros países del mundo y nos ayudan a ampliar nuestros conocimientos, interactuar con otras personas.

      En Somerset Language Centre, hemos diseñado unos cursos para quienes quieran aprender a desenvolverse en las situaciones más habituales en este idioma lo puedan hacer a su ritmo y de una forma amena."      
      imageOnRight={true}
    />
  );
};

const B2 = () => {
  return (
    <Section
      imageSrcs={["/b2.jpg"]}
      title="NIVEL B2"
      description="Cursos en los que se potencia la confianza del estudiante para desenvolverse por completo en inglés en cualquier circunstancia.
      Para ello, se crea un clima cómodo y relajante en el que los estudiantes pueden comunicarse de manera efectiva sobre todo tipo de temas, insistiendo en la pronunciación, la gramática y la aplicación de vocabulario específico.
      "
      imageOnRight={false}
    />
  );
};

const C1 = () => {
    return (
      <Section
        imageSrcs={["/c1_adultos.jpg"]}
        title="NIVEL C1"
        description="A este nivel, todas las competencias tienen que llegar a su grado más alto para aprobar los exámenes de Cambridge. 
        El Advanced (CAE) es un certificado de nivel avanzado de Cambridge y que demuestra la excelencia en el conocimiento y uso del inglés. Cubre las necesidades de obtener destrezas lingüísticas más concretas y profundas cada vez más demandadas en el mundo académico y profesional.
        "
        imageOnRight={true}
      />
    );
  };

const EsoBachiller = () => {
  return (
    
      <Stack direction="column" fontFamily={"Montserrat"} spacing={10}>
        <A2 />
        <B1 />
        <B2 />
        <C1/>
      </Stack>
  
  );
};



export default EsoBachiller;
